<template>
  <div class="real-time-info-page">
    <top-bar :topbarList="realTimeInfoTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";

import { realTimeInfoIndexMixins } from "@/mixins/realTimeInfoIndexMixins";

export default {
  mixins: [realTimeInfoIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.real-time-info-page {
  height: 100%;
}
</style>
